<template lang="html">
     <div class="form-floating w-100 mb-2">
        <select class="form-select select-floating"  v-model="selectedItem">
            <option v-for="item in itemsList" :key="item[itemKey]" :value="item" >
                {{ item[itemKey] }}
            </option>
        </select>
        <label v-if="selectedItem == null">{{ defaultLabel }}</label>
    </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    items: {
      type: [Array, Promise],
      default: () => []
    },
    currentValue: {
      type: Object,
      default: () => ({})
    },
    defaultLabel: {
      type: String,
      default: ""
    },
    shownKey: {
      type: String,
      default: ""
    },
    customClasses: {
      type: String,
      default: ""
    }
  },
  computed: {
    itemKey() {
      return !this.shownKey ? "name" : this.shownKey;
    }
  },
  data() {
    return {
      itemsList: [],
      active: false,
      selectedItem: this.currentValue || {}
    };
  },
  methods: {
    click() {
      this.active = !this.active;
    },
    closeListener(e) {
      if (!(this.$el && this.$el.contains(e.target))) {
        this.active = false;
      }
    }
  },
  async mounted() {
    if (this.items && typeof this.items.then === "function") {
      this.itemsList = await this.items;
    } else {
      this.itemsList = this.items || [];
    }
    document.addEventListener("click", this.closeListener, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeListener, true);
  },
  watch: {
    currentValue(newVal) {
      this.selectedItem = newVal;
    },
    selectedItem(newVal) {
      console.log("Option sélectionnée :", newVal);
      this.$emit("dropdownClick", newVal);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form-select {
    width: 100%;
}

.form-floating label {
    padding-left: 12px;
    font-size: 0.875rem;
}
</style>
